import script from "./WhoForHowMuch.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhoForHowMuch.vue?vue&type=script&lang=ts&setup=true"

import "./WhoForHowMuch.vue?vue&type=style&index=0&id=5e9fba3c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9fba3c"]])

export default __exports__